import * as React from 'react';
import { changeConfirmLocale } from 'antd/lib/modal/locale';

interface IItemProps {
  label?: string;
  style?: any;
  extra?: string;
  required?: boolean;
}

class Item extends React.Component<IItemProps> {

  render() {
    const { label, style, extra, required } = this.props;

    return (
      <div className="ant-row ant-form-item" style={...style}>
        {label &&
          <div className="ant-form-item-label">
            <label className={`${required === true ? 'ant-form-item-required' : ''}`} title={label}>
              {label}
            </label>
          </div>}

        <div className="ant-form-item-control-wrapper">
          <div className="ant-form-item-control">
            {this.props.children}

            {extra &&
              <div className="ant-form-extra" dangerouslySetInnerHTML={{ __html: extra }} />}

            <div className="ant-form-explain" />
          </div>
        </div>
      </div>
    );
  }
}

export default Item;


// WEBPACK FOOTER //
// ./src/components/Form/components/Item/Item.tsx